import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ServiciosTable = ({
  carro,
  currentIndex,
  servicios,
  selectedServicios,
  handleServicioSelectionChange,
}) => {
    const filteredServicios = servicios.filter(servicio => servicio.incluido);

  return (
    <>

      <h5>{`Servicios para ${carro[currentIndex].nombre_producto}`}</h5>

      <DataTable
        value={filteredServicios}
        selection={selectedServicios}
        onSelectionChange={handleServicioSelectionChange}
        className="p-datatable-gridlines"
        showGridlines
        dataKey="id"
        emptyMessage="No tiene servicios asociados"
      >
        <Column selectionMode="multiple" style={{ width: "3em" }} />
        <Column field="descripcion" header={
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className="pi pi-list" style={{ color: '#2196F3' }}></i>
            Servicios
          </div>
        } />
        <Column field="moneda" header={
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className="pi pi-dollar" style={{ color: '#4CAF50' }}></i>
            Moneda
          </div>
        } />
        <Column field="unidad" header={
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className="pi pi-chart-bar" style={{ color: '#FF9800' }}></i>
            Unidad Medida
          </div>
        } />
      </DataTable>
    </>
  );
};

export default ServiciosTable;
